<div class="card-container-shadow mb-xlg">
  <div class="title-section mb-md">
    <h2 class="text-title-md-bold">Historial de mediciones</h2>
    <p class="text-info mt-xxs">Puedes mostrar el historial de mediciones solo añadiendo filtros</p>
  </div>
  <!-- <div class="title-section mb-md">
    <h2 class="text-title-md-bold d-flex justify-content-between tw-w-full">
      <div class="tw-w-full">
        <p class="">Historial de mediciones</p>
        <p class="text-info mt-xxs">Puedes mostrar el historial de mediciones solo añadiendo filtros</p>
      </div>
    </h2>
  </div> -->
  <div class="select-objectives">
    <div nz-row [nzGutter]="[0, 7]">
      <div nz-col *ngFor="let measurement of historial.headers; index as i">
        <nz-tag class="tag" [class.cursor-pointer]="true" nz-popover="" nzPopoverTitle="" [nzPopoverContent]="!measurement?.hide ? 'Ocultar columna' :
          'Mostrar columna'" [style.background-color]="!measurement.hide ? (i | setColorByIndex) : ''" (click)="onToggleShowColumnTable(measurement)"
          @fadeInAnimation>
          {{ measurement.name_es }}
        </nz-tag>
      </div>
    </div>
  </div>

  <p class="text-info mb-xs mt-xlg d-flex align-items-center" *ngIf="historial && historial.headers">
    <span class="color-change-value mr-xxs"></span>Refiere que hubo un cambio en el valor.
  </p>
  <p class="text-info mb-xs mt-xs d-flex align-items-center" *ngIf="historial && historial.headers">
    <span class="color-autogenerate mr-xxs"></span>Medida generada automáticamente por el sistema.
  </p>
  <nz-table
    *ngIf="historial && historial.headers"
    nzTableHeaderStyle
    #measurementsTable
    [nzVirtualItemSize]="44"
    [nzData]="[0]"
    [nzFrontPagination]="false"
    [nzShowPagination]="false"
    class="fix-column mt-xlg"
    [nzScroll]="{ x: (((historial.headers | filterArray:'hide':'false')?.length * 200) + 250) + 'px', y: '500px' }"
    [ngStyle]="{'min-width': '250px'}"
    [tableIndex]="tableIndex"
    nzSize="small">
    <thead>
      <tr class="header">
        <th nzWidth="250px" *ngIf="historial.headers.length> 0">FECHA</th>
        <ng-container *ngFor="let column of historial.headers">
          <th nzWidth="200px" class="truncate" *ngIf="!column?.hide">
            <span nz-popover="" nzPopoverTitle="" [nzPopoverContent]="column.name_es">
              {{ column.name_es }}
            </span>
          </th>
        </ng-container>
        <th nzWidth="50px" nzRight="6px" *ngIf="historial.headers.length> 0 && showActions && userLogged?.experts"></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of historial.data; index as i">
        <td>{{ item.name | date:'MMM d, y, h:mm:ss a'}}</td>
        <ng-container *ngFor="let cell of item.patientMeasurements; index as j">
          <td *ngIf="!historial.headers[j]?.hide" [class.cursor-pointer]="cell?.value !== '-' && !cell?.automaticallyGenerated">
            <span nz-popover=""
              *ngIf="!item.edit"
              nzPopoverTitle=""
              [nzPopoverContent]="descriptionTpl"
              nzPopoverTrigger="null"
              [nzPopoverVisible]="!!registerInfo && i === registerInfo['indexRow'] && j === registerInfo['indexCol']"
              (nzPopoverVisibleChange)="$event ? registerInfo= registerInfo : registerInfo= null"
              (click)="onVewInfoRegister(cell, i, j)"
              [class.is-new-value]="historial.data[i + 1]?.patientMeasurements[j] && cell?.value !== historial.data[i +
              1]?.patientMeasurements[j]?.value"
              [class.is-generate-value]="cell.automaticallyGenerated">
              <span [class.dot-is-generate-value]="cell.automaticallyGenerated"></span>
              {{ cell?.value === '-' ? '-' : (+cell.value).toFixed(2)}} {{ cell?.measureUnit?.symbol_es ?? '' }}
            </span>
            <nz-input-number *ngIf="item.edit" [(ngModel)]="cell.newValue" [nzMin]="0.1" [nzStep]="1"
              (ngModelChange)="onChangeInputValue(item, j, $event)"></nz-input-number>
          </td>
        </ng-container>
        <td nzWidth="50px" nzRight *ngIf="showActions && userLogged?.experts">
          <i nz-icon (click)="onSaveRow(item)" *ngIf="item.edit" nzType="check-circle" nzTheme="fill" class="icon-done-edit" nz-popover=""
            nzPopoverTitle="" [nzPopoverContent]="'Guardar valores'"></i>
          <i nz-icon nzType="close-circle" (click)="onCancelEdit(item)" *ngIf="item.edit" nzTheme="outline" class="icon-cancel-edit ml-xs" nz-popover=""
            nzPopoverTitle="" [nzPopoverContent]="'Cancelar'"></i>
          <div class="more-options" *ngIf="!item.edit">
            <div class="more" nz-dropdown nzTrigger="click" [nzDropdownMenu]="menu">
              <i nz-icon nzType="ellipsis" nzTheme="outline"></i>
            </div>
          </div>
          <nz-dropdown-menu #menu="nzDropdownMenu">
            <ul nz-menu nzSelectable>
              <li nz-menu-item (click)="onEditMode(item)">
                <i style="margin-right: 5px;" nz-icon nzType="edit" nzTheme="outline"></i>
                editar
              </li>
              <li nz-menu-divider></li>
              <li nz-menu-item nzDanger (click)="onDelete(item)">
                <i style="margin-right: 5px;" nz-icon nzType="delete" nzTheme="outline"></i>
                eliminar
              </li>
            </ul>
          </nz-dropdown-menu>
        </td>
      </tr>
    </tbody>
  </nz-table>
  <nz-empty *ngIf="(historial && historial.headers && historial.headers.length === 0) || !historial.headers" class="mb-xlg" nzNotFoundContent="No hay
    registros de mediciones"></nz-empty>
</div>

<ng-template #descriptionTpl>
  <div class="content-description">
    <div class="d-flex flex-column justify-content-center align-items-center" *ngIf="registerInfo">
      <p class="text-info-sm opacity-70 mb-xs">Medida registrada por</p>
      <div class="d-flex align-items-center justify-content-center">
        <app-avatar-user [image]="registerInfo.profileImageURL" [name]="registerInfo.name" [lastname]="registerInfo.lastname" [width]="32"></app-avatar-user>
        <p class="ml-xs text-info">{{ registerInfo.name }} {{ registerInfo.lastname }}</p>
      </div>
    </div>
  </div>
</ng-template>
